import React from 'react';
import { LoadState } from '../../../types/LoadState';
import { VarderingarAutocomplete } from './VarderingarAutocomplete';
import { BostadAutocompleteDto } from '../../types/dtos/VarderingarModel';

export const mapSelectedAdress = (adress: BostadAutocompleteDto | string) => {
  if (!adress) {
    return '';
  } else if (typeof adress === 'string') {
    return adress;
  } else if (!adress.postort) {
    return adress.text;
  }

  const lagenhetsnummer = !adress.lagenhetsnummer
    ? ''
    : `, lgh ${adress.lagenhetsnummer}`;
  return `${adress.text}, ${adress.postort}${lagenhetsnummer}`;
};
interface AdressAutocompleteProps {
  loadState: LoadState;
  adressOptions: BostadAutocompleteDto[];
  setSelectedAdress: (value: BostadAutocompleteDto) => void;
  inputValue: string;
  setInputValue: (value: string) => void;
}

export const AdressAutocomplete: React.FC<AdressAutocompleteProps> = ({
  loadState,
  adressOptions,
  setSelectedAdress,
  inputValue,
  setInputValue,
}) => {
  const noValues: BostadAutocompleteDto[] =
    loadState === LoadState.Loading
      ? []
      : [
          {
            text: 'Inga alternativ',
            selectable: false,
          } as BostadAutocompleteDto,
        ];

  const selectValues =
    adressOptions.length === 0 && inputValue ? noValues : adressOptions;

  return (
    <VarderingarAutocomplete
      sx={{ flex: 1 }}
      label="Adress"
      options={selectValues}
      getOptionDisabled={(o) => o.text === 'Inga alternativ'}
      onChange={(_event, selectedValue) => {
        if (typeof selectedValue === 'object') {
          setSelectedAdress(selectedValue);
        }
      }}
      inputValue={inputValue}
      onInputChange={(_e, val) => setInputValue(val)}
      isOptionEqualToValue={(option, value) =>
        mapSelectedAdress(option) === mapSelectedAdress(value)
      }
      filterOptions={(o) => o}
      getOptionLabel={mapSelectedAdress}
      loadState={loadState}
    />
  );
};
